import { NgModule } from '@angular/core';
import { MaterialModule } from './material.module';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { SilentCheckSsoComponent } from './silent-check-sso/silent-check-sso.component';
import { CustomSnackbarComponent } from './custom-snackbar/custom-snackbar.component';
import { CustomSnackbarContentComponent } from './custom-snackbar-content/custom-snackbar-content.component';
import { LimsDropdownComponent } from './common/lims-dropdown/lims-dropdown.component';
import { CommonModule } from '@angular/common';
import { CustomSnackbarNoDataComponent } from './custom-snackbar-no-data/custom-snackbar-no-data.component';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { LimsReportViewerComponent } from './common/lims-report-viewer/lims-report-viewer.component';
import { ReportViewerModule } from 'ngx-ssrs-reportviewer';
import { LimsDropdownTooltipComponent } from './common/lims-dropdown-tooltip/lims-dropdown-tooltip.component';
import { MonthYearDirective } from './format-datepicker/month-year.directive';
import { OnlyYearDirective } from './format-datepicker/only-year.directive';
import { NumberFormat, numberFloatFormat, numberFormatDots } from '../data/schema/vi-date-picker-adapter';
import { NgxDropdownComponent } from './angiang/ngx-dropdown/ngx-dropdown.component';
import { BarChartComponent } from './angiang/chart-js/bar-chart/bar-chart.component';
import { PieChartComponent } from './angiang/chart-js/pie-chart/pie-chart.component';
import { ChartsModule } from 'ng2-charts';
import { LineChartComponent } from './angiang/chart-js/line-chart/line-chart.component';
import { TrimWhiteSpaceDirective } from 'layout/trim-white-space/trim-white-space.directive';
import { LimsPaginatorComponent } from './common/lims-paginator/lims-paginator.component';
import { LimsTableComponent } from './common/lims-table/lims-table.component';
import { DynamicFormComponent } from './common/dynamic-form/dynamic-form.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
    declarations: [
        SilentCheckSsoComponent,
        CustomSnackbarComponent,
        CustomSnackbarContentComponent,
        CustomSnackbarNoDataComponent,
        LimsDropdownComponent,
        LimsDropdownTooltipComponent,
        LimsReportViewerComponent,
        MonthYearDirective,
        OnlyYearDirective,
        TrimWhiteSpaceDirective,
        NumberFormat,
        numberFloatFormat,
        NgxDropdownComponent,
        BarChartComponent,
        LineChartComponent,
        PieChartComponent,
        numberFormatDots,
        LimsPaginatorComponent,
        LimsTableComponent,
        DynamicFormComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        HttpClientModule,
        ReactiveFormsModule,
        TableVirtualScrollModule,
        ReportViewerModule,
        ChartsModule,
        NgxMatSelectSearchModule
    ],
    exports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        HttpClientModule,
        LimsDropdownComponent,
        LimsDropdownTooltipComponent,
        LimsReportViewerComponent,
        MonthYearDirective,
        OnlyYearDirective,
        TrimWhiteSpaceDirective,
        NumberFormat,
        numberFloatFormat,
        NgxDropdownComponent,
        BarChartComponent,
        LineChartComponent,
        PieChartComponent,
        numberFormatDots,
        LimsPaginatorComponent,
        LimsTableComponent,
        DynamicFormComponent
    ]
})
export class SharedModule { }
